import MealsPage from './MealsPage';
export default MealsPage;
